export default __webpack_public_path__ + "static/media/V - STRAP.649a645e.jpg";